<template>
  <section>
    <output v-show="isDebug">{{ JSON.stringify(anteriorStroke) }} </output>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="526"
      height="391"
      viewBox="0 0 526 391"
      fill="none"
    >
      <rect width="526" height="391" fill="url(#pattern0_11_8)" />
      <g id="M5">
        <path
          @click="selected('M5')"
          :class="anteriorStroke.includes('M5') ? 'selected' : ''"
          d="M475 146H487C487 146 497 183 502 211C507 239 496 239 496 239L475 232L469.5 216V192L464 152L470 146"
          fill="#CBC3E3"
          stroke="black"
        />
      </g>
      <path
        @click="selected('M4')"
        :class="anteriorStroke.includes('M4') ? 'selected' : ''"
        fill="red"
        d="M441 105C448.816 132.137 454.047 141.081 465 145L481 139C471.475 120.178 465.24 110.17 453 93C446.397 95.7697 443.586 98.2135 441 105Z"
        stroke="black"
      />

      <path
        @click="selected('M3')"
        :class="anteriorStroke.includes('M3') ? 'selected' : ''"
        fill="#235284"
        d="M237 252.057L210 240C210 240 192 254.35 192 266C192 277.65 215 286.057 215 286.057L237 252.057Z"
        stroke="black"
      />
      <path
        @click="selected('M2')"
        :class="anteriorStroke.includes('M2') ? 'selected' : ''"
        fill="#FFCC00"
        d="M212 240L237 247V205L227 148H212L204 154L212 240Z"
        stroke="black"
      />
      />

      <path
        @click="selected('M1')"
        :class="anteriorStroke.includes('M1') ? 'selected' : ''"
        fill="orange"
        d="M227 148H205L184 116V102L200 92L216 116L227 148Z"
        stroke="black"
      />
      <path
        @click="selected('C')"
        :class="anteriorStroke.includes('C') ? 'selected' : ''"
        fill="blue"
        d="M158 163L165 141L140 154L149 179L158 163Z"
        stroke="black"
      />
      />

      <path
        @click="selected('IC')"
        :class="anteriorStroke.includes('IC') ? 'selected' : ''"
        fill="#90EE90"
        d="M169 145L173 148L157 175L178 207L169 214L150 191L163 145"
        stroke="black"
      />
      />
      <path
        @click="selected('L')"
        :class="anteriorStroke.includes('L') ? 'selected' : ''"
        fill="#8B0000"
        d="M175 157L183 189L175 205L158 182L172 153"
        stroke="black"
      />
      />

      <path
        @click="selected('I')"
        :class="anteriorStroke.includes('I') ? 'selected' : ''"
        fill="#301934"
        d="M191 143L184 137V170L191 189L184 202H191L199 189V170L191 143Z"
        stroke="black"
      />
      />

      <path
        @click="selected('M6')"
        :class="anteriorStroke.includes('M6') ? 'selected' : ''"
        fill="#ADD8E6"
        d="M497 245C497 245 487.154 239.734 477 237C474 226 450 263 450 263L471 284L497 245Z"
        stroke="black"
      />
      />
    </svg>
  </section>
</template>

<script setup lang="ts">
import {
  Contexts,
  CurrentCaseServiceInterface,
  getContainer,
  getContext,
  Helpers,
  NamedBindings,
  ApplicationEvents,
  Version,
  CoreConfiguration,
} from '@dandelion/core';
import { onBeforeMount, ref, Ref } from 'vue';
import { isEqual } from 'lodash';

const props = defineProps<{
  context: string;
  fullName: string;
  id: string;
}>();

const coreConfiguration = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CoreConfiguration
) as CoreConfiguration;
const currentCaseService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CurrentCaseService
) as CurrentCaseServiceInterface;

const anteriorStroke = ref<Array<string>>([]);
const isDebug = coreConfiguration.debug;

async function selected(selected: string) {
  const model = (await useCurrentContext(props!.context)).model;

  if (anteriorStroke.value.includes(selected)) {
    anteriorStroke.value = anteriorStroke.value.filter(
      (item: string) => item !== selected
    );
  } else {
    anteriorStroke.value.push(selected);
  }
  Helpers.setObjByPath(props.fullName, model, anteriorStroke.value);
}

onBeforeMount(async () => {
  const model = (await useCurrentContext(props!.context)).model;
  const anteriorStrokeFromModel = Helpers.getObjByPath(props.fullName, model);

  if (!anteriorStroke.value) {
    return;
  }
  anteriorStroke.value = anteriorStrokeFromModel ?? [];
});

async function useCurrentContext(context = Contexts.DEFAULT) {
  let crfVersions: Readonly<Ref<ReadonlyMap<string, Version>>> = ref(new Map());
  try {
    crfVersions = ref(currentCaseService.getCrfVersions());
  } catch (e) {
    // TODO: maybe remove error thrown, there are cases when no version is available
    // e.g. the context is not set, no current patient etc.
  }
  const model = await currentCaseService.getModel();
  const keyForReRender = ref(0);

  getContext(context).addEventListener(
    ApplicationEvents.CaseOpenedForEditing,
    async () => {
      const currentCrfVersions = currentCaseService.getCrfVersions();
      if (!isEqual(currentCrfVersions, crfVersions)) {
        crfVersions = currentCrfVersions;
      }
      keyForReRender.value = keyForReRender.value + 1;
    }
  );
  return { keyForReRender, crfVersions, model };
}
</script>
<style scoped>
path {
  opacity: 0.15;
}
path:hover {
  cursor: pointer;
  opacity: 0.3;
}

.selected {
  cursor: pointer;
  opacity: 0.8 !important;
}
</style>
